import { __ } from '../../../translations';
import { isGuestUser } from '../../../config/guestMode';
import { getUserInfo } from '../../../utils/user';

export const useRentButtonTitle = (tvodInfo) => {
    let tvodRentNowBtnText = __('tvod_rent_now_button_details');
    const priceWithVat = tvodInfo?.priceWithVat;
    const currency = isGuestUser(getUserInfo()) ? '' : 'SAR';

    if (priceWithVat) {
        tvodRentNowBtnText = tvodRentNowBtnText.replace('{priceWithVat}', `<label  dir="ltr"> ${priceWithVat}`);
    } else {
        tvodRentNowBtnText = tvodRentNowBtnText.replace(' - {priceWithVat}', ``);
    }
    tvodRentNowBtnText = tvodRentNowBtnText.replace('{currency}', currency ? `${currency}</label>` : '');
    tvodRentNowBtnText = tvodRentNowBtnText.replace(/<label(.*?)>/g, '<span$1>').replace(/<\/label>/g, '</span>');
    return tvodRentNowBtnText;
};
